import { HttpClient } from '@angular/common/http';
import {
  Component,
  inject,
  OnInit,
  signal,
  ViewEncapsulation,
} from '@angular/core';
import { IVersion } from '@devinforius/i-essentials';

@Component({
  selector: 'im-support',
  templateUrl: './support.component.html',
  styleUrl: './support.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class SupportComponent implements OnInit {
  private readonly http = inject(HttpClient);
  public supportDetails = {
    text: 'Support',
    phone: '+32 081 74 43 40',
    email: 'support@inforius.be',
  };

  public readonly versions = signal<IVersion[]>([]);

  ngOnInit(): void {
    this.http
      .get<{
        versions: (Omit<IVersion, 'shortDescription'> & { notes: string[] })[];
      }>('assets/versions/versions.json')
      .subscribe(
        (file: {
          versions: (Omit<IVersion, 'shortDescription'> & {
            notes: string[];
          })[];
        }) => {
          this.versions.set(
            file.versions.map((version) => ({
              ...version,
              shortDescription: version.notes.join('\n'),
            })),
          );
        },
      );
  }

  public onGuideClick(): void {}
}
